import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { loginUser, isAuthenticated } from "../../services/authService";
import logo from "../../assets/images/logo.png";
import "./Login.css";

const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // Redirect if already logged in
        if (isAuthenticated()) {
            navigate("/dashboard");
        }
    }, [navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (!username || !password) {
            setError("Username and password are required");
            return;
        }

        try {
            setLoading(true);
            await loginUser(username, password);
            navigate("/"); // Redirect to dashboard on success
        } catch (err) {
            setError(err.response?.data?.message || "Login failed. Please check your credentials.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="logo-container">
                <img src={logo} alt="Company Logo"/>
            </div>

            <div className="login-box">
                <div className="left-section">
                    <h2>Welcome</h2>
                    <p>Sign in to continue</p>
                </div>
                <div className="right-section">
                    <h2>Sign In</h2>
                    {error && <div className="error-message">{error}</div>}
                    <form onSubmit={handleSubmit}>
                        <input
                            type="text"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                        <input
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <button
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? "LOGGING IN..." : "LOGIN"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;